import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Testimonials from './components/Testimonials';
import CTA from './components/CTA';
import Footer from './components/Footer';

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen">
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
        <div className="px-8 py-5">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center">
                <i className="ri-store-3-line text-3xl text-rose-400"></i>
              </div>
              <span className={`text-xl font-serif font-semibold ${scrolled ? 'text-gray-900' : 'text-white'}`}>Mount Zion Investment INC</span>
            </div>

            <div className="flex items-center gap-10">
              <a href="#services" className={`text-sm font-light transition-colors cursor-pointer ${scrolled ? 'text-gray-700 hover:text-gray-900' : 'text-white hover:text-gray-200'}`}>Our Stores</a>
              <a href="#about" className={`text-sm font-light transition-colors cursor-pointer ${scrolled ? 'text-gray-700 hover:text-gray-900' : 'text-white hover:text-gray-200'}`}>About</a>
              <a href="#services" className={`text-sm font-light transition-colors cursor-pointer ${scrolled ? 'text-gray-700 hover:text-gray-900' : 'text-white hover:text-gray-200'}`}>Beauty & Skincare</a>
              <a href="#services" className={`text-sm font-light transition-colors cursor-pointer ${scrolled ? 'text-gray-700 hover:text-gray-900' : 'text-white hover:text-gray-200'}`}>New Arrivals</a>
              <a href="#contact" className={`text-sm font-light transition-colors cursor-pointer ${scrolled ? 'text-gray-700 hover:text-gray-900' : 'text-white hover:text-gray-200'}`}>Contact</a>
            </div>

            <button className={`px-6 py-2.5 rounded-full border transition-all whitespace-nowrap cursor-pointer ${scrolled ? 'border-rose-400 text-rose-500 hover:bg-rose-500 hover:text-white' : 'border-white text-white hover:bg-white hover:text-gray-900'}`}>
              Visit a Store
            </button>
          </div>
        </div>
      </nav>

      <Hero />
      <About />
      <Services />
      <Testimonials />
      <CTA />
      <Footer />
    </div>
  );
}